<template>
    <footer class="footer_box">
        <div
            class="footer_content"
        >
            <div class="left">
                <template>
                    <div
                        v-for="item in footerModule"
                        :key="item.value"
                        class="item"
                    >
                        <div class="title">
                            {{ item.title }}
                        </div>
                        <span
                            v-for="(el, index) in item.children"
                            :key="el.title || index"
                            class="el_link"
                        >
                            <span v-if="el.isKYC" @click="routerOpen(el)">
                                {{ el.title }}
                            </span>
                            <a
                                v-else-if="el.url.length > 32"
                                :href="el.url"
                                target="_blank"
                            >{{ el.title }}</a>
                            <router-link
                                v-else-if="el.url"
                                :to="el.url"
                            >{{ el.title }}</router-link>
                            <span
                                v-else
                                @click="selectUrl(el)"
                            >{{ el.title }}</span>
                        </span>
                    </div>
                </template>
            </div>
            <div class="right m-t-20">
                <div class="community">
                    Poynex {{ $t('message.footer.community') }}
                </div>
                <div class="w-222">
                    <span
                        v-for="(item, index) in icons"
                        :key="item.type"
                        :style="{ 'margin-right': index === 5 ? 0 : '20px' }"
                        class="item_icon"
                        :class="[item.link ? 'pointer' : '']"
                        @click="handleJump(item)"
                    >
                        <span
                            @mouseenter="iconSelected = item.type"
                            @mouseleave="iconSelected = null"
                        >
                            <img
                                class="icon"
                                :src="iconSelected === item.type ? item.imgUrlY : item.imgUrl"
                                alt=""
                            >
                        </span>
                        </router-link>
                    </span>
                </div>
                <div class="email">
                    support@Poynex.net
                </div>
                <el-dropdown
                    v-if="false"
                    class="link"
                    placement="bottom"
                    @visible-change="visibleEnvironDropdown"
                >
                    <div>
                        <span :style="{ 'margin-right': '49px' }">{{ `${currentLanguage}/${currency}` }}</span>
                        <i class="el-icon-caret-bottom" />
                    </div>
                    <environ-dropdown
                        ref="environDropdown"
                        class="footer_environ_dropdown"
                        :language-list="languageList"
                        :currency-list="currencyList"
                    />
                </el-dropdown>
            </div>
        </div>

        <div class="copyright"> Poynex@ 2024 </div>
        <!-- 个人认证对话框 -->
        <basic-dialog
            title=""
            :visible.sync="showAuthenticDialog"
            :confirm-text="$t('tv_personal_authentication')"
            :show-btn="true"
            @confirm="
                $router.push('/account/kyc/personal');
                showAuthenticDialog = false;
            "
            @close="showAuthenticDialog = false"
            @cancel="showAuthenticDialog = false"
        >
            <div class="text-center">
                <img
                    class="h-32 w-32 m-lr-6"
                    src="@/assets/buyCoinsImg/bussiness_icon.png"
                    alt=""
                />
                <p class="font-16 text-white m-l-24">
                    {{ $t('message.TransferMoney.personal.certification') }}
                </p>
            </div>
        </basic-dialog>
    </footer>
</template>
<script>
import EnvironDropdown from './environDropdown';
import { mapState } from 'vuex';
import BasicDialog from '@/components/basic/BasicDialog';
import { defaultCoin } from '@/enum/index';
export default {
    name: 'FooterBox',
    components: { EnvironDropdown, BasicDialog },
    data () {
        return {
            defaultCoin,
            showAuthenticDialog: false,
            footerModule: [],
            icons: [
                {
                    type: 'twitter',
                    imgUrl: require('@/assets/common/twitter.png'),
                    imgUrlY: require('@/assets/common/twitter_y.png'),
                    link: 'https://twitter.com/VaultyMinGroup'
                },
                {
                    type: 'facebook',
                    imgUrl: require('@/assets/common/facebook.png'),
                    imgUrlY: require('@/assets/common/facebook_y.png'),
                    link: 'https://www.facebook.com/PoynexGroup'
                },
                {
                    type: 'tg',
                    imgUrl: require('@/assets/common/tg.png'),
                    imgUrlY: require('@/assets/common/tg_y.png')
                },
                {
                    type: 'utube',
                    imgUrl: require('@/assets/common/utube.png'),
                    imgUrlY: require('@/assets/common/utube_y.png')
                },
                {
                    type: 'in',
                    imgUrl: require('@/assets/common/in.png'),
                    imgUrlY: require('@/assets/common/in_y.png')
                },
                {
                    type: 'reddit',
                    imgUrl: require('@/assets/common/reddit.png'),
                    imgUrlY: require('@/assets/common/reddit_y.png')
                },
                {
                    type: 'medium',
                    imgUrl: require('@/assets/common/medium.png'),
                    imgUrlY: require('@/assets/common/medium_y.png')
                },
                {
                    type: 'discord',
                    imgUrl: require('@/assets/common/discord.png'),
                    imgUrlY: require('@/assets/common/discord_y.png')
                },
                {
                    type: 'ins',
                    imgUrl: require('@/assets/common/ins.png'),
                    imgUrlY: require('@/assets/common/ins_y.png')
                }
            ],
            iconSelected: null
        };
    },
    computed: {
        ...mapState({
            language: state => state.user.language,
            currency: state => state.user.currency,
            articleList: state => state.footer.articleList,
            aboutList: state => state.footer.aboutList,
            currencyList: state => state.user.rate_list,
            languageList: state => state.user.languageList,
            langObj: state => state.user.langObj
        }),
        currentLanguage () {
            return this.langObj[this.language];
        }
    },
    created () {
        this.initModule();
        this.$store.dispatch('footer/getArticleList').then((res) => {
            if (this.aboutList?.child && this.aboutList?.child.length > 0) {
                const child = this.footerModule[0].children;
                this.aboutList.child.forEach((el, index) => {
                    if (child[index]) {
                        child[index].title = el.title;
                        child[index].url.query = { id: el.id };
                    }
                });
            }
        });
    },
    methods: {
        routerOpen(row) {
            const { idcard_state } = this.user_info;
            if (idcard_state !== 3) {
                this.showAuthenticDialog = true;
                return;
            }
            this.$router.push(row.url);
        },
        handleJump(item) {
            if (item.link) {
                window.open(item.link, '_blank');
            }
        },
        initModule () {
            this.footerModule = [
                {
                    title: this.$t('message.footer.aboutUs'),
                    children: [
                        {
                            title: this.$t("message.user.LegalNotices"),
                            url: { name: 'AboutUs', params: { menuType: 'about'}, query: { id: 6 }}
                        },
                        {
                            title: this.$t("message.user.PlatformIntroduction"),
                            url: { name: 'AboutUs', params: { menuType: 'terms' }, query: { id: 15 }}
                        },
                        {
                            title: this.$t('message.user.PrivacyPolicy'),
                            url: { name: 'AboutUs', params: { menuType: 'privacy'}, query: { id: 14 }}
                        },
                        {
                            title: this.$t('message.user.protocol'),
                            url: { name: 'AboutUs', params: { menuType: 'state' }, query: { id: 13 }}
                        }
                    ],
                    value: 0
                },
                {
                    title: this.$t('message.footer.product'),
                    children: [
                        {
                            title: this.$t('message.footer.spotDeal'),
                            url: { name: 'Transaction', params: { tradePair: 'BTC_USDT' }}
                        },
                        // {
                        //     title: this.$t('message.footer.fiatDeal'),
                        //     url: { name: 'BuyCustorm' }
                        // },
                        {
                            title: this.$t('message.footer.sustainable'),
                            url: {
                                name: 'FuturesTrade',
                                params: { tradePair: `BTC${this.defaultCoin}` }
                            }
                        },
                        {
                            title: 'ICO',
                            url: { path: '/home/finance/index/icoKey' }
                        },
                        {
                            title: this.$t('message.footer.download'),
                            url: ''
                        },
                        {
                            title: this.$t('message.footer.derivatives'),
                            url: ''
                        }
                    ],
                    value: 1
                },
                {
                    title: this.$t('message.footer.serve'),
                    children: [
                        {
                            title: this.$t('message.footer.upCoin'),
                            url: {
                                path: '/my/wallet/account/main/deposit/crypto/Blockchain/USDT'
                            },
                            isKYC: true
                        },
                        {
                            title: this.$t('message.footer.buyCoin'),
                            url: { path: '/my/wallet/account/main/deposit/crypto/USDT' }
                        },
                        // {
                        //     title: this.$t('message.footer.rebate'),
                        //     url: '/referral'
                        // },
                        {
                            title: this.$t('message.footer.bulk'),
                            url: ''
                        },
                        {
                            title: this.$t('message.footer.custom'),
                            url: ''
                        },
                        {
                            title: this.$t('message.footer.Affiliate'),
                            url: ''
                        }
                    ],
                    value: 2
                }
                // {
                //     title: this.$t('message.footer.help'),
                //     children: [
                //         {
                //             title: this.$t('message.footer.help'),
                //             url: { name: 'Help' }
                //         },
                //         {
                //             title: this.$t('message.footer.service'),
                //             url: ''
                //         },
                //         {
                //             title: this.$t('message.footer.rate'),
                //             url: { name: 'TradeRate' }
                //         },
                //         {
                //             // api文档
                //             title: this.$t('message.footer.api'),
                //             url: ''
                //         },
                //         {
                //             title: this.$t('message.footer.suggest'),
                //             url: ''
                //         }
                //     ],
                //     value: 3
                // }
            ];
        },
        visibleEnvironDropdown (visible) {
            console.log(visible);
            if (visible) {
                this.$store.dispatch('user/getRateList');
                this.languageList.forEach(el => {
                    if (el.value === this.language) {
                        this.$refs.environDropdown.currentLanguage = el.name;
                    }
                });
                this.currencyList.forEach((el, index) => {
                    if (el.tocoin === this.currency) {
                        this.$refs.environDropdown.currentCurrency = index;
                    }
                });
            }
        },
        selectUrl (el) {
            if (!el.url) {
                this.$message({
                    message: this.$t('message.footer.develop'),
                    duration: 1000
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
$max-width: 1200px;

@mixin common-title() {
  font-size: 20px;
  font-family: PingFang_Medium;
  color: $basicWhite;
  margin-bottom: 20px;
  line-height: 23px;
}

.footer_box {
  padding-top: 40px;
//   padding-top: 40px;
  padding-bottom: 10px;
  background-color: #141515;

  .footer_content {
    display: flex;
  //  padding-bottom: 60px;
    margin-top:40px;
    max-width: $max-width;
    margin: 0 auto;
    justify-content: space-between;
  }

  .left {
    display: flex;
    justify-content: flex-start;

    .item {
      display: flex;
      flex-direction: column;
      margin-right: 100px;

      &:last-child {
        margin-right: 0;
      }

      .title {
        @include common-title();
      }

      .el_link {
        font-size: 14px;
        color: #848E9C;
        margin-bottom: 20px;
        line-height: 14px;

        &>span {
          font-family: PingFang_Regular;
        }

        &>a {
          font-family: PingFang_Regular;
        }

        &:hover {
          color: $basicColor;
          cursor: pointer;
        }
      }
    }
  }

  .right {
    .community {
      @include common-title();
    }
    .email {
      color: #808C9A;
      margin-bottom: 10px;
    }

    .item_icon {
      margin-bottom: 20px;
      display: inline-block;
      font-size: 0;
      &.pointer {
        cursor: pointer;
      }

      .icon {
        width: 20px;
        height: 20px;
      }
    }
  }

  .el-dropdown {
    width: 179px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #B7BDC6;
    line-height: 40px;
    text-align: center;
  }

  .copyright {
   // border-top: 1px solid #2A2A36;
    text-align: center;
    padding-top: 10px;
    font-size: 12px;
    font-family: PingFang_Regular;
    color: #636B75;
  }
}
</style>
<style lang="scss">
.footer_environ_dropdown {

  // top: 3885px !important;
  .popper__arrow {
    display: none !important;
  }
}
</style>
